import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Science } from './components/Science';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="w-full min-h-screen font-sans bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <div className="pt-20" data-id="element-3">
          <Hero data-id="element-4" />
          <Problem data-id="element-5" />
          <Solution data-id="element-6" />
          <Science data-id="element-7" />
          <div id="beneficios" data-id="element-8">
            <Benefits data-id="element-9" />
          </div>
          <div id="testimonios" data-id="element-10">
            <Testimonials data-id="element-11" />
          </div>
          <div id="precios" data-id="element-12">
            <Pricing data-id="element-13" />
          </div>
          <Guarantee data-id="element-14" />
          <div id="faq" data-id="element-15">
            <FAQ data-id="element-16" />
          </div>
          <Footer data-id="element-17" />
        </div>
      </div>
    </LanguageProvider>;
}